import { useSelector } from "react-redux";
import { getUserPermissions } from '../../data/permissions/permissionsSlice';

export default function PolicyCheck({ reqPolicies, disabled, hidden, children }) {
    const userPermissions = useSelector(getUserPermissions);
    let allowed = userPermissions && userPermissions.length > 0 && userPermissions.some(p => reqPolicies.includes(p));

    return allowed ?
        children : disabled ?
            <div style={{ opacity: 0.5, pointerEvents: 'none' }}>{children}</div> : hidden ?
                null : null;
}